import { render, staticRenderFns } from "./NavMenuGroup.vue?vue&type=template&id=f1a2a75a&scoped=true"
import script from "./NavMenuGroup.vue?vue&type=script&lang=js"
export * from "./NavMenuGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a2a75a",
  null
  
)

export default component.exports